var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "estate-card" }, [
      _c("a", { attrs: { href: "#" } }, [
        _c("img", {
          staticClass: "estate-carousel-image skeleton",
          attrs: { src: "/img/estate-placeholder-skeleton.png", height: "400" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "estate-card-box-data" }, [
          _c("div", { staticClass: "estate-card-price" }, [
            _c("div", { staticClass: "estate-card-current-price" })
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "estate-card-title" }),
          _vm._v(" "),
          _c("h4", { staticClass: "estate-card-subtitle" })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }